import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@components';
import usePageTitle from '@hooks/usePageTitle';
import useLayoutContext from '@hooks/useLayoutContext';

const CaptivePortalGuest = () => {
  usePageTitle('Guest Account');
  const history = useHistory();
  const { loginToCaptivePortal } = useLayoutContext();
  return (
    <div className="flex justify-center py-3">
      <div className="w-full space-y-2 md:w-4/5 md:max-w-lg">
        <div className="mb-2 text-center">
          <h2 style={{ fontSize: '125%' }} className="pb-5">
            Guest access is limited duration and limited bandwidth.
          </h2>
        </div>
        If you are a Resident or Staff user, please go back and create an account or sign&nbsp;in.
        <div className="flex justify-around gap-3">
          <Button layout="secondary" className="w-full mt-3" onClick={() => history.goBack()}>
            Go Back
          </Button>
          <Button
            className="w-full mt-3"
            onClick={() => {
              loginToCaptivePortal();
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CaptivePortalGuest;
